import React, { useEffect } from 'react'
import Navbar from '../../components/Navbar'
import FeatureHighlight from '../../components/cultivars/FeatureHighlight'
import ProductShowcase from '../../components/cultivars/MasterKushUltra/ProductShowcase'
import Footer from '../../components/Footer'
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";
import { Helmet } from 'react-helmet'

const MasterKushUltra = () => {
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
        <Helmet>
        <title>Master Kush Ultra - Deeply Relaxing with Earthy Aroma | BeyondBloom™</title>
        <meta
          name="description"
          content="Master Kush Ultra is a potent indica strain known for its deeply relaxing effects and pungent earthy aroma. Perfect for unwinding and stress relief."
        />
        <meta
          name="keywords"
          content="Master Kush Ultra strain, indica cannabis, relaxation, pungent earthy aroma, premium cannabis, BeyondBloom"
        />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta
          property="og:title"
          content="Master Kush Ultra - Deeply Relaxing with Earthy Aroma | BeyondBloom™"
        />
        <meta
          property="og:description"
          content="Master Kush Ultra is a potent indica strain known for its deeply relaxing effects and pungent earthy aroma. Perfect for unwinding and stress relief."
        />
        <meta property="og:image" content="/images/mk-ultra.png" />
        <meta property="og:url" content="https://yourwebsite.com/cultivars/master-kush-ultra" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Master Kush Ultra - Deeply Relaxing with Earthy Aroma | BeyondBloom™"
        />
        <meta
          name="twitter:description"
          content="Master Kush Ultra is a potent indica strain known for its deeply relaxing effects and pungent earthy aroma. Perfect for unwinding and stress relief."
        />
        <meta name="twitter:image" content="/images/mk-ultra.png" />
      </Helmet>
    <Navbar/>
    <ProductShowcase/>
    <FeatureHighlight/>
    <CultivarDisplay />
    <Cta />
    <Footer/>
</>
  )
}

export default MasterKushUltra